import {Card} from "react-bootstrap";
import {InputSuspense, TxtSuspense} from "_components/suspense/parts";
import {Page} from "_page/Page";
import {Skeleton} from "@mui/material";
import React from "react";
import {VStack} from "_ui/Box";
import {ButtonSuspense} from "_components/suspense/ButtonSuspense";

const Item = () => {
    return (
        <Skeleton variant="rectangular" width="100%" height={90} />
    );
}

export const ListSuspense = () => {
    return (
        <Page>
            <Card>
                <Card.Header>
                    <Card.Title>
                        <TxtSuspense w={200}/>
                    </Card.Title>
                </Card.Header>

                <Card.Body>
                    <VStack g={2}>
                        <div className='mb-2 w-100 gap-2'>
                            <InputSuspense h={40}/>
                            <TxtSuspense w={100}/>
                        </div>

                        <Item/>
                        <Item/>
                        <Item/>
                    </VStack>
                </Card.Body>
                <Card.Footer>
                    <ButtonSuspense w={120}/>
                </Card.Footer>
            </Card>
        </Page>
    )
}
